/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_VARIANCE_DATA,
  SET_TAX_TYPE_WISE_DATA,
  SET_LATE_FEE_DATA,
  SET_CASH_ITC_AGG_DATA,
  SET_CASH_ITC_DATA,
  SET_CLEAR_GRAPH
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  cashVsItcData: [],
  cashVsItcAggData: [],
  intrAndltfeeAggData: [],
  taxTypeWiseData: []
};

/* eslint-disable default-case, no-param-reassign */
const TaxDischargedAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_CASH_ITC_DATA:
      return {
        ...state,
        cashVsItcData: action.cashVsItcData
      };
    case SET_CASH_ITC_AGG_DATA:
      return {
        ...state,
        cashVsItcAggData: action.cashVsItcAggData
      };
    case SET_LATE_FEE_DATA:
      return {
        ...state,
        intrAndltfeeAggData: action.intrAndltfeeAggData
      };
    case SET_TAX_TYPE_WISE_DATA:
      return {
        ...state,
        taxTypeWiseData: action.taxTypeWiseData
      };
    case SET_CLEAR_GRAPH:
      return {
        ...state,
        cashVsItcData: [],
        cashVsItcAggData: [],
        intrAndltfeeAggData: [],
        taxTypeWiseData: []
      };
    default:
      return state;
  }
};

export default TaxDischargedAnalysisReducer;
